// src/services/deviceId.js
// Device UUID generated once on first load, never cleared (survives cache clear).
// Must NOT live in <script setup> (named exports aren't allowed there).

if (!localStorage.getItem('deviceId')) {
  localStorage.setItem('deviceId', crypto.randomUUID());
}

export const DEVICE_ID = localStorage.getItem('deviceId');
